import React, { useState } from "react";
import Modal from "../../components/Modal";
import { RotatingLines } from "react-loader-spinner";
import { toast } from "react-toastify";
import { useAuth } from "../../context/Auth";
import Swal from "sweetalert2";

const CashierSaleItemReturn = ({ modalOpen, setModalOpen,  sale_item }) => {
  const { requestWithAuth } = useAuth();
  const [submittingForm, setSubmittingForm] = useState(false);
  const [paymentData, setPaymentData] = useState({
    sale_item:sale_item?.id
  });
  

    const handleFormChange = (e) => {
        setPaymentData({
            ...paymentData, [e.target.name] : e.target.value
        })
    }

  const handlePayment = async (e) => {
    e.preventDefault();
    
    if(parseInt(paymentData['returning_quantity']) > parseInt(sale_item?.quantity)){
        return toast.error("Returning quantity must not be higher than quantity sold")
    }
    Swal.fire({
      icon: "question",
      title: "Are you sure you want to proceed?",
      showDenyButton: true,
      confirmButtonText: "Yes Proceed!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        
        try {
          setSubmittingForm(true);
          const body = JSON.stringify(paymentData);
          
          const data = await requestWithAuth(
            `/inventory/sale-item-return/`,
            "POST",
            body,
            {
              "Content-Type": "application/json",
            }
          );
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: "Sale Item Return Recorded Successfully. Pending Approval.",
          }).then(() => {
            window.location.reload();
          });
        } catch (error) {
          toast.error("Something went wrong!");
        } finally {
          setSubmittingForm(false);
        }
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  return (
    <div>
      <Modal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        title="Item Return"
      >
        <form onSubmit={(e) => handlePayment(e)}>
          <div className="grid grid-cols-2 gap-5">
            <div className="flex flex-col gap-2">
              <label htmlFor="" className="font-bold">
                Drug Name
              </label>
              <input
                type="text"
                className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                value={sale_item?.drug}
                disabled
              />
            </div>
            <div className="flex flex-col gap-2">
              <label htmlFor="" className="font-bold">
                Quantity Sold
              </label>
              <input
                type="text"
                value={sale_item?.quantity}
                className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                disabled
              />
            </div>

            <div className="flex flex-col gap-2">
              <label htmlFor="" className="font-bold">
                Returning Quantity*
              </label>
              <input
                type="text"
                name="returning_quantity"
                onChange={(e)=>handleFormChange(e)}
                className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                required
              />
            </div>

            <div className="flex flex-col gap-2">
              <label htmlFor="" className="font-bold">
                Returning Reason*
              </label>
              <input
                type="text"
                required
                min="0"
                name="return_reason"
                onChange={(e)=>handleFormChange(e)}
                className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
              />
            </div>


          </div>
          <div className="flex items-center justify-end gap-6 mt-7">
            <div className="cursor-pointer" onClick={() => setModalOpen(false)}>
              Close
            </div>
            {submittingForm ? (
              <div className="bg-blue-400 flex items-center gap-2 rounded px-4 py-2 text-white ">
                <RotatingLines strokeColor="white" height="12" width="12" />{" "}
                Submitting
              </div>
            ) : (
              <button className="bg-blue-500 hover:bg-blue-600 rounded px-4 py-2 text-white ">
                Submit Form
              </button>
            )}
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default CashierSaleItemReturn;
